import { useState, useEffect } from 'react';
import { FiUsers, FiPackage, FiDollarSign, FiMessageSquare } from 'react-icons/fi';
import TransactionStatementModal from './TransactionStatementModal';
import UserListModal from './UserListModal';

const StatsCards = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeOrders: 0,
    platformRevenue: 0,
    activeSellers: 0,
    activeBuyers: 0,
    completedOrders: 0,
    commissionRate: 20
  });
  const [showStatementModal, setShowStatementModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        const response = await fetch("/api/admin/stats", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.success && data.data) {
          setStats({
            totalUsers: data.data.totalUsers || 0,
            activeOrders: data.data.activeOrders || 0,
            platformRevenue: data.data.platformRevenue || 0,
            activeSellers: data.data.activeSellers || 0,
            activeBuyers: data.data.activeBuyers || 0,
            completedOrders: data.data.completedOrders || 0,
            commissionRate: 20
          });
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };
    fetchStats();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Card 1 - Total Users (Clickable) */}
        <div 
          onClick={() => setShowUserModal(true)}
          className="bg-white p-5 rounded-xl shadow-sm border-l-4 border-[#708238] transition-all duration-300 hover:bg-[#FFA500] hover:text-white cursor-pointer"
        >
          <div className="flex justify-between">
            <div>
              <p className="text-gray-600 text-sm group-hover:text-white">Total Users</p>
              <p className="text-2xl font-bold">{stats.totalUsers}</p>
              <p className="text-xs text-green-500 mt-1 group-hover:text-white">↑ 12% from last month</p>
            </div>
            <div className="bg-[#f0f4e4] p-3 rounded-full h-fit">
              <FiUsers className="text-[#708238] text-xl" />
            </div>
          </div>
        </div>

        {/* Card 2 - Active Orders */}
        <div className="bg-white p-5 rounded-xl shadow-sm border-l-4 border-[#708238] transition-all duration-300 hover:bg-[#FFA500] hover:text-white cursor-pointer">
          <div className="flex justify-between">
            <div>
              <p className="text-gray-600 text-sm">Active Orders</p>
              <p className="text-2xl font-bold">{stats.activeOrders}</p>
              <p className="text-xs text-green-500 mt-1">↑ 8% from last week</p>
            </div>
            <div className="bg-[#fff0cc] p-3 rounded-full h-fit">
              <FiPackage className="text-[#FFA500] text-xl" />
            </div>
          </div>
        </div>

        {/* Card 3 - Platform Revenue (Clickable for statement) */}
        <div 
          onClick={() => setShowStatementModal(true)}
          className="bg-white p-5 rounded-xl shadow-sm border-l-4 border-[#708238] transition-all duration-300 hover:bg-[#FFA500] hover:text-white cursor-pointer"
        >
          <div className="flex justify-between">
            <div>
              <p className="text-gray-600 text-sm">Platform Revenue</p>
              <p className="text-2xl font-bold">
                ${stats.platformRevenue.toLocaleString()}
              </p>
              <p className="text-xs text-green-500 mt-1">↑ 15% from last month</p>
            </div>
            <div className="bg-blue-100 p-3 rounded-full h-fit">
              <FiDollarSign className="text-blue-600 text-xl" />
            </div>
          </div>
        </div>

        {/* Card 4 - Commission Rate (20%) */}
        <div className="bg-white p-5 rounded-xl shadow-sm border-l-4 border-[#708238] transition-all duration-300 hover:bg-[#FFA500] hover:text-white cursor-pointer">
          <div className="flex justify-between">
            <div>
              <p className="text-gray-600 text-sm">Commission Rate</p>
              <p className="text-2xl font-bold">{stats.commissionRate}%</p>
              <p className="text-xs text-gray-500 mt-1">Current rate</p>
            </div>
            <div className="bg-[#f0f4e4] p-3 rounded-full h-fit">
              <FiMessageSquare className="text-[#708238] text-xl" />
            </div>
          </div>
        </div>
      </div>

      <TransactionStatementModal
        isOpen={showStatementModal}
        onClose={() => setShowStatementModal(false)}
        adminToken={localStorage.getItem("adminToken")}
      />

      <UserListModal
        isOpen={showUserModal}
        onClose={() => setShowUserModal(false)}
        adminToken={localStorage.getItem("adminToken")}
      />
    </>
  );
};

export default StatsCards;
